import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';
/* styles */
import './reset-password-error.scss';

function ResetPasswordErrorPage(props) {
    const forgotPasswordLink = `/Account/ForgotPassword?ReturnUrl=${encodeURIComponent(props.model.returnUrl || '/')}`;
    return (
        <AuthWrapper heading="Error">
            <section className="sten-content__section sten-reset-password-error-page__icon-wrapper">
                <span className="icon icon-exclamation-circle" />
            </section>
            <section className="sten-content__section text-center text-center">
                <p>Your reset link has already been used.</p>
            </section>
            <div className="sten-content__separator" />
            <section className="sten-content__section text-center">
                <p>If you still wish to reset your password click <a href={forgotPasswordLink}>here</a>.</p>
            </section>
        </AuthWrapper>
    );
}

ResetPasswordErrorPage.propTypes = {
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default ResetPasswordErrorPage;
